import { useEditFeedback, useFeedbackById } from '@services/feedback'
import type { ModalProps } from '@shared/Modal'
import Modal from '@shared/Modal'
import useEdit from '@shared/hooks/useEdit'
import useVisible from '@shared/innmaxLib/hooks/useVisible'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoilCallback } from 'recoil'
import OptionsModal from 'src/components/Modal'
import { FormState } from 'src/components/Repair'
import BasicForm from './TabPanes/BasicForm'

type Props = {
  item: any
  currentTab?: string
  readOnly?: boolean
  showMap?: boolean
  onOk: (val?: any) => void
  onCancel: (val?: any) => void
  onOkDeletion: (val?: any) => any
} & Omit<ModalProps, 'onCancel'>

export function RepairModal({
  readOnly = false,
  showMap = true,
  onCancel,
  onOk,
  onOkDeletion,
  ...props
}: Props) {
  const { t } = useTranslation()

  const confirmModal = useVisible<any>()

  const { loading, data, refetch } = useFeedbackById(props.item?.id)

  const { isCreate, isEdit, handleEdit } = useEdit<{ id: string } | undefined>({
    item: data as any,
  })

  const [updating, handleUpdate] = useEditFeedback({
    onSuccess: () => {
      refetch()
      handleEdit()
      onOk()
    },
    onError: () => {},
  })

  const handleOk = React.useCallback(
    (values: any) => {
      handleUpdate({
        ...data,
        ...values,
        id: data?.id,
      })
    },
    [data] //eslint-disable-line
  )

  const fieldProps = React.useMemo(
    () => ({
      item: data,
      isEdit,
      readOnly,
      isCreate,
      loading,
      onOk: handleOk,
      onCancel,
      onEdit: handleEdit,
    }),
    [data, isEdit, readOnly] //eslint-disable-line
  )

  const getFieldsChange = useRecoilCallback(({ snapshot }) => async () => {
    const changeValue = await snapshot.getPromise(FormState)
    return changeValue
  })

  const handleBeforeCancel = async () => {
    const value = await getFieldsChange()
    if (value) {
      confirmModal.open()
      return
    } else {
      onCancel && onCancel()
    }
  }

  return (
    <>
      {confirmModal.visible && (
        <OptionsModal.ConfirmUpdateModal
          onCancel={confirmModal.close}
          onLeave={onCancel}
        />
      )}
      <Modal
        centered={false}
        open
        title={`${isCreate ? '新增' : isEdit ? '編輯' : ''} 聯絡表單 ${
          data?.title ? `- ${data?.title}` : ''
        }`}
        width={'80dvw'}
        style={{
          top: 20,
        }}
        loadingData={loading || updating}
        onCancel={handleBeforeCancel}
        bodyStyle={{
          padding: 0,
        }}
        footer={false}>
        <BasicForm {...fieldProps} />
      </Modal>
    </>
  )
}

export default React.memo(RepairModal)
